import { publicApi } from '@shared/api/axios-instance';

export interface RefreshResponse {
  access_token: string;
  refresh_token: string;
}

const refreshRequests = new Map<string, Promise<RefreshResponse>>();

export async function refreshAccessToken(refreshToken: string) {
  const activeRequest = refreshRequests.get(refreshToken);
  if (activeRequest) return activeRequest;

  const request = publicApi
    .post<RefreshResponse>('/api/auth/refresh', null, {
      headers: {
        Authorization: `Bearer ${refreshToken}`,
      },
    })
    .then(({ data }) => data)
    .finally(() => {
      refreshRequests.delete(refreshToken);
    });

  refreshRequests.set(refreshToken, request);
  return request;
}
